import IndicadorDashboardItem from "./IndicadorDashboardItem";
import Processo from "./Processo";
import UnidadeOrganizacional from "./UnidadeOrganizacional";

export default class IndicadorDashboard {
    id: number | null;
    processo: Processo | null;
    unidadeOrganizacional: UnidadeOrganizacional | null;
    codigo: string;
    nome: string;
    unidadeMedida: string | null;
    dataInicioColeta: Date | null;
    itens: IndicadorDashboardItem[] = []

    constructor(
        id  = 0,
        processo = null,
        unidadeOrganizacional = null,
        codigo = '',
        nome = '',
        unidadeMedida = null,
        dataInicioColeta: Date | null = null
    ){
        this.id = id;
        this.processo = processo;
        this.unidadeOrganizacional = unidadeOrganizacional;
        this.codigo = codigo;
        this.nome = nome;
        this.unidadeMedida = unidadeMedida;
        this.dataInicioColeta = dataInicioColeta;
    }
}